<list-view *ngIf="listeWorkflow" [liste]="listeWorkflow"></list-view>
<floating-button [listeActions]="listeActions"></floating-button>
